<template>
  <!--  banner 轮播部分-->
<!--  <page-banner :pageNumber="2" />-->
  <crumbs></crumbs>
  <div class="mainContainer">
<!--    <switch-page-tabbar>-->
<!--      <nuxt-link to="/gywm/jtjj">集团简介</nuxt-link>-->
<!--      <nuxt-link to="/gywm/zzjg">组织架构</nuxt-link>-->
<!--      <nuxt-link to="/gywm/lqqx" class="active">路桥旗下</nuxt-link>-->
<!--      <nuxt-link to="/gywm/qyry">企业荣誉</nuxt-link>-->
<!--    </switch-page-tabbar>-->
    <div class="detail" style="display:flex;">
      <show-content :detail="detail" :noSubTitle="true"/>
      <div class="recommend">
        <div class="title">{{detail.typeName}}</div>
        <nuxt-link :to="'/gywm/lqqx/'+item.id" class="li" v-for="item in recommendList" :key="item.id">{{item.companyName}}</nuxt-link>
        <nuxt-link to="/gywm/lqqx" class="backList" @click="">返回列表
          <img src="~images/pages/public/backArrow.png" alt="backArrow">
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import {getGWRecommendedSubCompany, getItsDetail} from "../../../apis/gywm";


const Route = useRoute()
const id = ref(Route.params.id)


const detail = ref({})
const itsRes = await useAsyncData("getItsDetail", () => getItsDetail(id.value));
if (itsRes.data.value.code !== 200) {
  detail.value = {}
  throw createError({statusCode: itsRes.data.value.code, statusMessage: encodeURIComponent("获取路桥旗下详情数据失败")})
} else {
  let _detail = itsRes.data.value.data;
  let _dict = {
    "1": '全资公司',
    "2": '分公司',
    "3": '控股公司',
    "4": '参股公司',
  }
  detail.value['typeName'] = _dict[_detail.companyType]
  detail.value['contentTitle'] = _detail.companyName
  detail.value['content'] = _detail.companyContent
}

const recommendList = ref([])
const listRes = await useAsyncData("getGWRecommendedSubCompany", () => getGWRecommendedSubCompany(id.value))
if (listRes.data.value.code !== 200) {
  throw createError({statusCode: listRes.data.value.code, statusMessage: encodeURIComponent("获取路桥旗下详情推荐列表数据失败")})
}else {
  recommendList.value = listRes.data.value.data;
}

</script>

<style scoped lang="scss">
.recommend {
  margin-left: 80px;
  .title {
    font-size: 24px;
    line-height: 1;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    margin-top: 64px;
    &:before {
      content: "";
      display: inline-block;
      width: 7px;
      height: 20px;
      background: var(--main-blue-color);
      margin-right: 4px;
    }
  }
  .li {
    font-size: 16px;
    line-height: 24px;
    color: var(--secondary-text-color);
    margin-bottom: 24px;
    width: 200px;
    cursor: pointer;
    display: flex;
    align-items: center;
    &:before {
      width: 6px;
      height: 6px;
      content: "";
      display: inline-block;
      background: var(--main-blue-color);
      margin-right: 10px;
      flex-shrink: 0;
    }
    &:hover {
      color: var(--main-blue-color);
    }
  }
  .backList {
    padding: 0 20px;
    line-height: 40px;
    border-radius: 25px;
    background: var(--main-blue-color);
    color: var(--white);
    font-size: 16px;
    cursor: pointer;
    display: inline-block;
    margin-left: -7px;
    text-decoration: none;
    margin-bottom: 30px;
    > img {
      width: 14px;
      height: 12px;
    }
  }
}
</style>